import React from "react";
import { useRouteError } from "react-router-dom";

import ConfirmDialog from "@components/common/ConfirmDialog";
import Header from "@components/common/Header";
import { AlertTriangle, Home, LogIn } from "lucide-react";
import { useTranslation } from "react-i18next";

const ErrorPage: React.FC<{ message?: string }> = ({
  message = "Something went wrong!",
}) => {
  const { t } = useTranslation();
  const [showLogoutConfirmation, setShowLogoutConfirmation] =
    React.useState(false);
  const error: any = useRouteError();
  console.error(error);

  return (
    <>
      <Header />
      {showLogoutConfirmation && (
        <ConfirmDialog
          text="Are you sure you want to logout?"
          confirmAction={() => {
            window.location.href = window.location.origin + "/signout/";
          }}
          rejectAction={() => setShowLogoutConfirmation(false)}
          show={showLogoutConfirmation}
          closeDialog={() => setShowLogoutConfirmation(false)}
        />
      )}
      <div className="flex flex-col justify-center items-center h-[calc(100vh-11rem)]">
        <AlertTriangle className="text-red-500 mb-10 drop-shadow-lg !w-20 !h-20" />
        <div className="text-xl font-bold">{message}</div>
        <div className="flex gap-4 mt-6">
          <div
            onClick={() => (window.location.href = window.location.origin)}
            className="cursor-pointer flex gap-2 items-center shadow-lg bg-primaryBlue px-4 py-2 text-white rounded-md text-sm"
          >
            <Home size={16} />
            <span>{t("common.go_to_homepage")}</span>
          </div>
          <div
            onClick={() => setShowLogoutConfirmation(true)}
            className="cursor-pointer flex gap-2 items-center shadow-lg bg-primary px-4 py-2 text-white rounded-md text-sm"
          >
            <LogIn size={16} />
            <span>{t("common.go_to_login_page")}</span>
          </div>
        </div>
        {/* <h1 className="text-3xl text-primary-text">Page not found</h1>
        <p>
          <i>{error.statusText || error.message}</i>
        </p> */}
      </div>
    </>
  );
};

export default ErrorPage;
